<template>
  <div class="page">
    <mobileHeader title="流转流程" rightType="scanCode"></mobileHeader>
    <div class="center">
      <GasCylinderInfo v-if="!isMultiple" :bottleInfo="bottleInfo" @showBottleUserInfo="showBottleUserInfo(bottleInfo)" />
      <bottleList @showBottleUserInfo="showBottleUserInfo" v-else />
      <!-- <div class="speed-of-progress">
        <template v-for="(it, i) in list">
          <div v-if="it.state" :key="i" :style="`transform: rotate(${((i + 1) * 36) + 27}deg);z-index:3;`">
            <img class="item-title" @click="touchItem(it)" :src="stateImages[bottleInfo.button == (it.state) ? (it.title + '-act') : it.title]" :style="`transform: rotate(-${((i + 1) * 36) + 27}deg);`">
          </div>
          <div
            v-else
            :key="i + 10"
            :style="`transform: rotate(${(((i + 1) * 2 - 2) * 36) + 27}deg);z-index:0;`"
          >
            <img src="@/assets/images/transform.png" alt="" />
          </div>
        </template>
      </div> -->
      <div class="speed-of-progress-list">
        <div class="speed-of-progress-item" v-for="(item, index) in lists" @click="touchItem({state: item.state})" :key="index">
          <img v-if="bottleInfo.button == item.state" :src="item.act" alt="">
          <img v-else :src="item.no" alt="">
        </div>
      </div>
      <div class="other">
        <div
          class="other-item"
          v-for="(it, i) in otherList"
          :key="i"
          @click="touchItems(it)"
        >
          <img :src="stateImages[it.title + '-act']" alt="">
          <div>{{ it.title }}</div>
        </div>
      </div>
    </div>
    <van-popup v-model="bottleUserInfoShow" position="center">
      <div class="bottle-user-info">
        <div class="bottle-user-info-name">用户名称：{{bottleUserInfo.name || "暂无"}}</div>
        <div class="bottle-user-info-phone">用户手机：{{bottleUserInfo.phone || "暂无"}}</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import mobileHeader from "@/components/mobileHeader";
import GasCylinderInfo from "@/components/GasCylinderInfo";
import bottleList from "@/components/bottleList";
import { Toast } from 'vant';
export default {
  data() {
    return {
      bottleId: null,
      Toast,
      list: [
        {
          title: "送气",
          state: 3,
        },
        {},
        {
          title: "使用",
          state: 4,
        },
        {},
        {
          title: "回收",
          state: 5,
        },
        {},
        {
          title: "充装",
          state: 1,
        },
        {},
        {
          title: "配送",
          state: 2,
        },
        {},
      ],
      lists: [
        {
          title: "充装（收发）",
          state: 1,
          no: require('@/assets/images/roam-new/cz-wdj.png'),
          act: require('@/assets/images/roam-new/cz-wdj.png')
          // noTouch: true
        },
        {
          title: "门店（收发）",
          state: 2,
          no: require('@/assets/images/roam-new/md-wdj.png'),
          act: require('@/assets/images/roam-new/md-dj.png')
        },
        {
          title: "送气（领瓶）",
          state: 3,
          no: require('@/assets/images/roam-new/sq-wdj.png'),
          act: require('@/assets/images/roam-new/sq-dj.png')
        },
        {
          title: "回收",
          state: 5,
          no: require('@/assets/images/roam-new/hs-wdj.png'),
          act: require('@/assets/images/roam-new/hs-dj.png')
        },
      ],
      otherList: [
        {
          title: "检测",
          state: 6,
        },
        {
          title: "报废",
          state: 7,
        },
        {
          title: "其他",
          state: 8,
        },
      ],
      state: 2,
      stateImages: {
        '充装': require('@/assets/images/充装.png'),
        '充装-act': require('@/assets/images/充装-act.png'),
        '回收': require('@/assets/images/回收.png'),
        '回收-act': require('@/assets/images/回收-act.png'),
        '配送': require('@/assets/images/配送.png'),
        '配送-act': require('@/assets/images/配送-act.png'),
        '使用': require('@/assets/images/使用.png'),
        '使用-act': require('@/assets/images/使用-act.png'),
        '送气': require('@/assets/images/送气.png'),
        '送气-act': require('@/assets/images/送气-act.png'),
        '检测': require('@/assets/images/检测.png'),
        '检测-act': require('@/assets/images/检测-act.png'),
        '报废': require('@/assets/images/报废.png'),
        '报废-act': require('@/assets/images/报废-act.png'),
        '其他': require('@/assets/images/其他.png'),
        '其他-act': require('@/assets/images/其他-act.png'),
      },
      bottleUserInfoShow: false,
      bottleUserInfo: {
        name: "",
        phone: ""
      },
    };
  },
  components: {
    mobileHeader,GasCylinderInfo, bottleList
  },
  async created() {
    console.log(this.$route,"router")
    console.log(808100000, this.$store.state.bottleId)
    // this.$store.state.isMultiple === false
    this.bottleId = this.$store.state.bottleId ? this.$store.state.bottleId : this.$route.query.bottleId
    const qrCode = this.$route.query.qrCode;
    console.log(this.$route.query, "this.$route.query");
    console.log(qrCode.indexOf(","),`qrCode.indexOf(",")`)
    if(qrCode.indexOf(",") != -1 || this.$store.state.isMultiple === true){
      this.$store.state.isMultiple = true
      const codeList = []
      qrCode.split(",").map(code => {
        codeList.push(this.mixDecode(code))
      })
      console.log(codeList,"codeList")
      if(this.$store.state.bottleIdList.length){
        this.$store.state.bottleIdList = this.$store.state.bottleIdList
      }else{
        const bottleListData = await this.mixfilterBottle(codeList)
        console.log(bottleListData, "bottleListData")
        // this.bottleListData = bottleListData
        this.$store.state.bottleListData = bottleListData
        
        this.$store.state.bottleIdList = bottleListData.map(it => it.ewm)
      }
      // this.$store.state.bottleIdList = this.$store.state.bottleIdList.length ? this.$store.state.bottleIdList : await this.mixfilterBottle(codeList)
      console.log(this.$store.state.bottleIdList,"this.$store.state.bottleIdList")
      return false
    }
    this.$store.state.isMultiple = false
    if(this.$store.state.bottleId)return this.mixGetBottleInfo(this.$store.state.bottleId)
    if (qrCode) {
      this.analysisCode({ data: qrCode });
    }
  },
  watch: {
    "$route.query.qrCode"(code){
      console.log(code,"========================")
    }
  },
  computed: {
    bottleInfo(){
      return this.$store.state.bottleInfo
    },
    userRole(){
      return this.$store.state.userRole
    },
    isMultiple(){
      return this.$store.state.isMultiple
    }
  },
  methods: {
    async touchItem({ state }) {
      console.log(state,"state")
      console.log(this.userRole,"this.userRole")
      console.log(this.$store.state.bottleId, 'bottleIdbottleIdbottleId')
      if(state == 1 )return Toast({message: "您不是充装员，没有权限操作", duration: 500})
      if(state == 2 && this.userRole != 1 )return Toast({message: "您不是店长，没有权限操作", duration: 500})
      if(state == 3 && this.userRole != 1 )return Toast({message: "您不是店长，没有权限操作", duration: 500})
      if(state == 5 && this.userRole != 1 )return Toast({message: "您不是店长，没有权限操作", duration: 500})
      if(this.isMultiple)return this.$router.push("/flowPath/collectNew?state="+state+"&isMultiple=1")
      const {code, msg} = await this.mixGetBottleInfo(this.$store.state.bottleId, state);
      code == 200 ? this.$router.push("/flowPath/collectNew?state="+state) : Toast({message: msg, duration: 500})
    },
    async touchItems({ state }) {
      console.log(this.$store.state.bottleId, 'bottleIdbottleIdbottleId')
      if(state == 1 )return Toast({message: "您不是充装员，没有权限操作", duration: 500})
      if(this.isMultiple)return this.$router.push("/flowPath/collect?state="+state+"&isMultiple=1")
      const {code, msg} = await this.mixGetBottleInfo(this.$store.state.bottleId, state);
      code == 200 ? this.$router.push("/flowPath/collect?state="+state) : Toast({message: msg, duration: 500})
    },
    async analysisCode({data}) {
      try{
        // const ret = JSON.parse(res.data);
        const ret = {
          bottleId: this.mixDecode(data)
        }
        console.log(ret,'ret123456789')
        if (!ret.bottleId)return (Toast({ message: "请扫正确的二维码", duration: 1000 }),setTimeout(_=>JS.close(), 1000));
        this.$store.state.bottleId = ret.bottleId;
        if (this.userRole == 3) {
          const { code, msg } = await this.mixGetBottleInfo(null, 1);
          code == 200
            ? this.$router.push("/flowPath/collect?state=" + 1)
            : Toast({ message: msg, duration: 500 });
        } else {
          const { code, msg } = await this.mixGetBottleInfo(ret.bottleId);
          // code == 200
          //   ? this.$router.push("/flowPath/index?bottleId=" + ret.bottleId)
          //   : Toast({ message: msg, duration: 500 });
          if(code != 200)return (Toast({ message: msg, duration: 1000 }),setTimeout(_=>JS.close(), 1000))

        }
      }catch(error){
        return (Toast({ message: "请扫正确的二维码", duration: 1000 }),setTimeout(_=>JS.close(), 1000));
      }
    },
    showBottleUserInfo({last_use_name, last_use_phone}){
      this.bottleUserInfo.name = last_use_name
      this.bottleUserInfo.phone = last_use_phone
      this.bottleUserInfoShow = true
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .header-title{
  font-size: 5vw;
}
.page {
  display: flex;
  background: #f7f7f7;
  height: auto;
  min-height: 100vh;
  width: 100vw;
  flex-direction: column;
  .center {
    flex-grow: 1;
    .speed-of-progress {
      width: 86%;
      position: relative;
      height: 90vw;
      margin-left: 8%;
      & > div {
        position: absolute;
        top: 50%;
        width: 100%;
        text-align: end;
        & > img {
          transform: rotate(81deg) translateY(8vw);
          margin-bottom: 9.5vw;
          width: 15vw;
        }
        .item-title {
          display: inline-block;
          height: 20vw;
          line-height: 20vw;
          width: 20vw;
          border-radius: 50%;
          text-align: center;
          margin: 0;
          margin-top: -9vw;
        }
        .item-title-act {
          background: #009900;
          color: white;
        }
        .item-title-act:active {
          opacity: 0.6;
        }
      }
    }
    .other {
      display: flex;
      padding: 0 9.2vw;
      justify-content: space-between;
      margin-top: 12.2vw;
      .other-item {
        text-align: center;
        font-size: 4.8vw;
        font-weight: 600;
        color: #333333;
        & > img {
          width: 17.8vw;
          height: 17.8vw;
          background: #d7d7d7;
          border-radius: 2vw;
          margin-bottom: 1.8vw;
        }
      }
    }
    .speed-of-progress-list{
      width:92vw;
      margin-left: 4vw;
      display: flex;
      flex-wrap: wrap;
      margin-top: 5vw;
      .speed-of-progress-item{
        width: 46vw;
        height: 29vw;
        img{
          width:100%;
          height: 100%;
        }
        img:active{
          opacity: 0.8;
        }
      }
    }
  }
  ::v-deep .van-popup{
    border-radius: 6px;
    overflow: hidden;
  }
  .bottle-user-info{
    min-width: 70vw;
    line-height: 40px;
    padding: 10px 20px;
  }
}
</style>
